/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Searchitemdesc2Inputs */

const id_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temukan apa yang Anda cari di Epic Games Store.`)
};

const ms_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari apa yang anda cari di Epic Games Store.`)
};

const da_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find hvad du leder efter på Epic Games Store.`)
};

const de_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finden Sie, wonach Sie im Epic Games Store suchen.`)
};

const en_us2_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find what you're looking for on the Epic Games Store.`)
};

const es_es2_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra lo que buscas en la Epic Games Store.`)
};

const es_mx2_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra lo que buscas en la Epic Games Store.`)
};

const fil_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanapin ang iyong hinahanap sa Epic Games Store.`)
};

const fr_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez ce que vous cherchez sur l'Epic Games Store.`)
};

const it_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova quello che cerchi sull'Epic Games Store.`)
};

const hu_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találd meg, amit keresel az Epic Games Store-ban.`)
};

const nl_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vind wat je zoekt in de Epic Games Store.`)
};

const no_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finn det du leter etter på Epic Games Store.`)
};

const pl_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź to, czego szukasz w Epic Games Store.`)
};

const pt_br2_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre o que você procura na Epic Games Store.`)
};

const pt_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre o que procura na Epic Games Store.`)
};

const ro_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Găsește ce cauți pe Epic Games Store.`)
};

const fi_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löydä etsimäsi Epic Games Storesta.`)
};

const sv_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitta vad du letar efter i Epic Games Store.`)
};

const vi_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm thấy những gì bạn đang tìm kiếm trên Epic Games Store.`)
};

const tr_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store'da aradığınızı bulun.`)
};

const cs_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najděte, co hledáte na Epic Games Store.`)
};

const bg_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Намерете това, което търсите в Epic Games Store.`)
};

const ru_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найдите то, что ищете в Epic Games Store.`)
};

const uk_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Знайдіть те, що шукаєте, у Epic Games Store.`)
};

const ar_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابحث عما تبحث عنه في Epic Games Store.`)
};

const hi_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store पर अपनी मनचाही चीज़ खोजें।`)
};

const th_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาสิ่งที่คุณต้องการบน Epic Games Store`)
};

const ja_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store でお探しのものを見つけましょう。`)
};

const zh_cn2_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在Epic游戏商城查找您需要的内容。`)
};

const zh_hant1_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在Epic遊戲商城尋找您需要的內容。`)
};

const ko_nav_searchitemdesc2 = /** @type {(inputs: Nav_Searchitemdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store에서 원하는 것을 찾아보세요.`)
};

/**
* | output |
* | --- |
* | "Find what you're looking for on the Epic Games Store." |
*
* @param {Nav_Searchitemdesc2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_searchitemdesc2 = /** @type {((inputs?: Nav_Searchitemdesc2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Searchitemdesc2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_searchitemdesc2(inputs)
	if (locale === "ms") return ms_nav_searchitemdesc2(inputs)
	if (locale === "da") return da_nav_searchitemdesc2(inputs)
	if (locale === "de") return de_nav_searchitemdesc2(inputs)
	if (locale === "en-US") return en_us2_nav_searchitemdesc2(inputs)
	if (locale === "es-ES") return es_es2_nav_searchitemdesc2(inputs)
	if (locale === "es-MX") return es_mx2_nav_searchitemdesc2(inputs)
	if (locale === "fil") return fil_nav_searchitemdesc2(inputs)
	if (locale === "fr") return fr_nav_searchitemdesc2(inputs)
	if (locale === "it") return it_nav_searchitemdesc2(inputs)
	if (locale === "hu") return hu_nav_searchitemdesc2(inputs)
	if (locale === "nl") return nl_nav_searchitemdesc2(inputs)
	if (locale === "no") return no_nav_searchitemdesc2(inputs)
	if (locale === "pl") return pl_nav_searchitemdesc2(inputs)
	if (locale === "pt-BR") return pt_br2_nav_searchitemdesc2(inputs)
	if (locale === "pt") return pt_nav_searchitemdesc2(inputs)
	if (locale === "ro") return ro_nav_searchitemdesc2(inputs)
	if (locale === "fi") return fi_nav_searchitemdesc2(inputs)
	if (locale === "sv") return sv_nav_searchitemdesc2(inputs)
	if (locale === "vi") return vi_nav_searchitemdesc2(inputs)
	if (locale === "tr") return tr_nav_searchitemdesc2(inputs)
	if (locale === "cs") return cs_nav_searchitemdesc2(inputs)
	if (locale === "bg") return bg_nav_searchitemdesc2(inputs)
	if (locale === "ru") return ru_nav_searchitemdesc2(inputs)
	if (locale === "uk") return uk_nav_searchitemdesc2(inputs)
	if (locale === "ar") return ar_nav_searchitemdesc2(inputs)
	if (locale === "hi") return hi_nav_searchitemdesc2(inputs)
	if (locale === "th") return th_nav_searchitemdesc2(inputs)
	if (locale === "ja") return ja_nav_searchitemdesc2(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_searchitemdesc2(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_searchitemdesc2(inputs)
	return ko_nav_searchitemdesc2(inputs)
});
export { nav_searchitemdesc2 as "nav.searchItemDesc" }